import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import OfferCard from "./OfferCard";
import OfferDetails from "./OfferDetails";
import ResourceCard from "./ResourceCard";
import "../styles/app.css";

export default function Tabs({ referralCode, offers, resources }) {
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const detailsRef = useRef(null);
  const swiperRef = useRef(null);

  const handleTabChange = (index) => {
    setTabIndex(index);
    setSelectedOffer(null);
    swiperRef.current?.slideTo(index); // Change swiper slide
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
  };

  // 🔄 Scroll to the details when selectedOffer changes
  useEffect(() => {
    if (selectedOffer && detailsRef.current) {
      setTimeout(() => {
        detailsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100); // delay to ensure DOM is ready
    }
  }, [selectedOffer]);

  return (
    <div className="tabs-wrapper">
      <div className="tabs">
        <button className={tabIndex === 0 ? "active" : ""} onClick={() => handleTabChange(0)}>
          Offer Wall
        </button>
        <button className={tabIndex === 1 ? "active" : ""} onClick={() => handleTabChange(1)}>
          Resources
        </button>
      </div>

      <Swiper
        spaceBetween={50}
        onSlideChange={(swiper) => handleTabChange(swiper.activeIndex)}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        initialSlide={tabIndex}
        style={{ padding: "20px 0" }}
      >
        <SwiperSlide>
          {!selectedOffer ? (
            <OfferCard offers={offers} onSelect={setSelectedOffer} />
          ) : (
            <div ref={detailsRef}>
              <OfferDetails offer={selectedOffer} 
              goBack={() => {
                setSelectedOffer(null);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }} />
            </div>
          )}
        </SwiperSlide>
        <SwiperSlide>
          <ResourceCard referralCode={referralCode} resources={resources} />
        </SwiperSlide>
      </Swiper>
    </div>
  );
}